import React from "react";
import {
  Box,
  Container,
  Heading,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import ComplianceQualityDashboard from "../components/ComplianceQualityDashboard";
import ClinicComplianceDashboard from "../components/ClinicComplianceDashboard";

const CompliancePage = () => (
  <Container maxW="container.xl" py={8}>
    <Box mb={6}>
      <Heading size="lg" mb={1}>
        Compliance & quality
      </Heading>
      <Text color="gray.600">
        Patient care compliance and internal clinic controls — one place for
        quality measures and SOC 2 / HIPAA audit readiness.
      </Text>
    </Box>

    <Tabs colorScheme="purple" variant="enclosed" isLazy>
      <TabList>
        <Tab fontWeight="semibold">Patients</Tab>
        <Tab fontWeight="semibold">Clinic</Tab>
      </TabList>
      <TabPanels>
        <TabPanel px={0} pt={6}>
          <ComplianceQualityDashboard />
        </TabPanel>
        <TabPanel px={0} pt={6}>
          <ClinicComplianceDashboard />
        </TabPanel>
      </TabPanels>
    </Tabs>
  </Container>
);

export default CompliancePage;
